import React, { Fragment } from 'react'
import { Link as RouterLink } from 'react-router-dom'
import { Heading, Text, List } from '../shared/typography'
import { StackView, HeadingUppercase } from '@planningcenter/tapestry-react'

const Results = ({ data, name, app }) => {
  let lastVersion = null

  return (
    <StackView axis="vertical" spacing={1}>
      <Heading>{name}</Heading>
      {data.length === 0 ? (
        <Text>No results</Text>
      ) : (
        <List>
          {data.map(result => {
            const { id, attributes } = result
            const isNew =
              !lastVersion || lastVersion !== attributes.version_name
            lastVersion = attributes.version_name
            return (
              <Fragment key={id}>
                {isNew && (
                  <HeadingUppercase
                    backgroundColor="primary-lightest"
                    marginLeft={-2}
                    marginBottom={1.5}
                    paddingHorizontal={1}
                    paddingVertical={0.5}
                  >
                    <RouterLink to={`/apps/${app}/${attributes.version_name}`}>
                      Version {attributes.version_name}
                    </RouterLink>
                  </HeadingUppercase>
                )}
                <List.Item marginLeft={2}>
                  {attributes.type} -{' '}
                  <RouterLink
                    to={`/apps/${app}/${attributes.version_name}/vertices/${attributes.vertex_id}`}
                  >
                    <Text as="span" inline weight={600}>
                      {attributes.name}
                      {attributes.type !== 'Vertex' &&
                        ` in ${attributes.vertex_name}`}
                    </Text>
                  </RouterLink>
                </List.Item>
              </Fragment>
            )
          })}
        </List>
      )}
    </StackView>
  )
}

export default Results
